import React from "react";
import { FormGroup } from "reactstrap";

// Bank Form Skeletons
export const ArabicNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const EnglishNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const FormSkeleton = () => {
  return (
    <>
      <ArabicNameFieldSkeleton />
      <EnglishNameFieldSkeleton />
    </>
  );
};

// Enhanced skeleton component for table rows
const SkeletonTableRow = ({ index = 0 }) => (
  <tr
    className="skeleton-table-row"
    style={{ animationDelay: `${index * 100}ms` }}
  >
    <td>
      <div className="skeleton skeleton-cell skeleton-cell--name-ar"></div>
    </td>
    <td>
      <div className="skeleton skeleton-cell skeleton-cell--name-en"></div>
    </td>
    <td>
      <div className="skeleton skeleton-cell skeleton-cell--action"></div>
    </td>
  </tr>
);

// Enhanced skeleton component for multiple rows with staggered animation
export const SkeletonTableRows = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <SkeletonTableRow key={`skeleton-${index}`} index={index} />
      ))}
    </>
  );
};

// Qualification Form Skeletons
export const QualificationArabicNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const QualificationEnglishNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const QualificationFormSkeleton = () => {
  return (
    <>
      <QualificationArabicNameFieldSkeleton />
      <QualificationEnglishNameFieldSkeleton />
    </>
  );
};

// City Form Skeletons
export const CityArabicNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const CityEnglishNameFieldSkeleton = () => {
  return (
    <FormGroup className="mb-3">
      <div
        className="skeleton"
        style={{ height: "20px", width: "150px", marginBottom: "8px" }}
      ></div>
      <div className="skeleton" style={{ height: "40px", width: "100%" }}></div>
    </FormGroup>
  );
};

export const CityFormSkeleton = () => {
  return (
    <>
      <CityArabicNameFieldSkeleton />
      <CityEnglishNameFieldSkeleton />
    </>
  );
};
